import React from 'react';
import { AuthContext } from './authProvider';

let useAuth = () => {
  let auth = React.useContext(AuthContext);
  return auth;
};
export default useAuth;
